"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHeadsetOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M25 12c0-6.62-3-10-9-10a8.8 8.8 0 00-6.5 2.25C7.82 5.93 7 8.46 7 12a5 5 0 000 10h2V12c0-3 .63-5 1.91-6.33C12 4.54 13.69 4 16 4c4.85 0 7 2.48 7 8v9.16a7.78 7.78 0 01-1.31 4 9.21 9.21 0 01-3.13 3l.88 1.8a11 11 0 003.91-3.67A10 10 0 0024.94 22H25a5 5 0 000-10zM7 20a3 3 0 010-6zm18 0v-6a3 3 0 010 6z" })));
}
exports.default = SvgHeadsetOutline;
//# sourceMappingURL=HeadsetOutline.js.map